export const frontends = {
  WEB_POS: 2,
  SPIFF: 3,
}
